<template>
  <v-form id="reset_fields" style="overflow-y: auto;" class="flex layout-column">
    <div class="flex layout-column" style="max-width: 700px;min-height:450px;">
      <ValidationObserver ref="welcomeForm" v-slot="{ valid, invalid, pristine, reset }" class="layout-column flex">

        <div class="flex layout-column" style="overflow-y:auto;">

          <div class="px-8 layout-column">
            <div class="my-5 white--text text--darken-2" v-html="$t('AUTH.WELCOME.DESCRIPTION')"/>

            <!-- firstname -->

            <validation-provider tag="div" ref="firstname" name="firstname" rules="required|min:2|name_string" v-slot="{ errors }">
              <v-text-field
                v-model="model.firstname"
                :error-messages="errors[0]"
                color="white"
                dark
                outlined
                dense
                v-on:keyup.enter="completeWelcome(valid)"
                prepend-inner-icon="supervised_user_circle"
                :label="$t('AUTH.WELCOME.FIRSTNAME') + '*'"
                :hint="$t('AUTH.WELCOME.FIRSTNAME')"
                autocomplete="off"
              ></v-text-field>
            </validation-provider>

            <!-- lastname -->

            <validation-provider tag="div" ref="lastname" name="lastname" rules="required|min:2|name_string" v-slot="{ errors }">
              <v-text-field
                v-model="model.lastname"
                :error-messages="errors[0]"
                color="white"
                dark
                outlined
                dense
                v-on:keyup.enter="completeWelcome(valid)"
                prepend-inner-icon="supervised_user_circle"
                :label="$t('AUTH.WELCOME.LASTNAME') + '*'"
                :hint="$t('AUTH.WELCOME.LASTNAME')"
                autocomplete="off"
              ></v-text-field>
            </validation-provider>

            <!-- login_name -->

            <validation-provider tag="div" ref="login_name" name="login_name" :rules="{required: true, unique_login_name: {token: token, email: model.email}}" v-slot="{ errors }">
              <v-text-field
                v-model="model.login_name"
                :error-messages="errors[0]"
                color="white"
                dark
                outlined
                dense
                autofocus
                v-on:keyup.enter="completeWelcome(valid)"
                prepend-inner-icon="supervised_user_circle"
                :label="$t('AUTH.WELCOME.USERNAME') + '*'"
                :hint="$t('AUTH.WELCOME.USERNAME_HINT')"
                type="text"
                autocomplete="off"
              ></v-text-field>
            </validation-provider>

            <!-- password -->
            <validation-provider tag="div" ref="password" name="password" rules="required|min:8" v-slot="{ errors }">
              <v-text-field
                v-model="model.password"
                :error-messages="errors[0]"
                color="white"
                dark
                outlined
                dense
                v-on:keyup.enter="completeWelcome(valid)"
                prepend-inner-icon="fingerprint"
                :label="$t('AUTH.WELCOME.PASSWORD_1') + '*'"
                placeholder=" "
                :hint="$t('AUTH.WELCOME.PASSWORD_1_HINT')"
                :clearable="false"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                @click:append="showPassword = !showPassword"
                @input="checkPasswordStrength"
                :type="showPassword ? 'text' : 'password'"
                autocomplete="off"
              ></v-text-field>
            </validation-provider>

            <!-- password confirmation -->
            <validation-provider tag="div" ref="confirmation" name="confirmation" rules="required|welcome_password:password|min:8" v-slot="{ errors }" style="height: 100px">
              <v-text-field
                color="white"
                dark
                placeholder=" "
                outlined
                dense
                v-on:keyup.enter="completeWelcome(valid)"
                :error-messages="errors[0]"
                :label="$t('AUTH.WELCOME.PASSWORD_2') + '*'"
                prepend-inner-icon="fingerprint"
                v-model="model.password2"
                :clearable="false"
                :append-icon="showPassword2 ? 'visibility' : 'visibility_off'"
                @click:append="showPassword2 = !showPassword2"
                :type="showPassword2 ? 'text' : 'password'"
                autocomplete="off"
              ></v-text-field>

              <div class="white--text text--darken-2">
                <div v-show="model.password" style="margin-top: -10px">{{ $t('AUTH.WELCOME.PASSWORD_STRENGTH.HINT') }}: <span :style="{ color: passwordStrength.color }" style="font-weight: bold;">{{ $t('AUTH.WELCOME.PASSWORD_STRENGTH.' + passwordStrength.score) }}</span></div>
              </div>
            </validation-provider>

            <v-alert class="ma-0 mt-2 elevation-3" color="blue-grey darken-1 white--text text--darken-2">{{ $t('AUTH.WELCOME.PASSWORD_CREATION_HINT') }}</v-alert>
          </div>
        </div>

        <v-divider class="mx-5"></v-divider>

        <div class="pa-2 d-flex flex-row">
          <div class="grow mr-1">
            <div class="grow">
              <lx-btn class="mr-1 text-none"
                      @click="completeWelcome(valid)"
                      color="green"
                      block
                      :disabled="!valid || invalid || pristine"
                      :label="$t('AUTH.WELCOME.BUTTONS.SUBMIT')"
                      :tooltip="$t('AUTH.WELCOME.BUTTONS.SUBMIT_HINT')"></lx-btn>
            </div>
          </div>
          <lx-btn class="text-none mr-1"
                  @click="clearForm(reset)"
                  color="white"
                  :disabled="pristine"
                  icon="clear"
                  :tooltip="$t('AUTH.WELCOME.BUTTONS.RESET_HINT')"></lx-btn>
        </div>
      </ValidationObserver>
    </div>
  </v-form>
</template>

<script>
import Vue from 'vue'
import router from '../../../router'

export default Vue.component('WelcomeComponent', {
  props: {
    token: {
      type: String,
      default: function () {
        return false
      }
    },
  },
  data () {
    return {
      passwordStrength: {
        score: 'BAD',
        color: 'red'
      },
      loading: false,
      model: {},
      showPassword: false,
      showPassword2: false
    }
  },
  created () {
    if (!this.token || (this.token.match(/^[0-9\-a-f]{36}$/i) === null)) {
      router.push({ path: `/auth/login` })
    } else {
      this.getData()
    }
  },
  methods: {
    getData () {
      if (this.loading) return
      this.loading = true

      this.$http.get('/pendingUser/' + this.token)
        .then((res) => {
          if (!res.data) {
            router.push({ path: '/' })
          } else {
            this.model = res.data
          }
        })
        .catch(() => {
          router.push({ path: '/' })
        })
        .finally(() => {
          this.loading = false
        })
    },

    scorePassword (pass) {
      let score = 0
      if (!pass)
        return score

      // award every unique letter until 5 repetitions
      let letters = {}
      for (let i = 0; i < pass.length; i++) {
        letters[pass[i]] = (letters[pass[i]] || 0) + 1
        score += 5.0 / letters[pass[i]]
      }

      // bonus points for mixing it up
      const variations = {
        digits: /\d/.test(pass),
        lower: /[a-z]/.test(pass),
        upper: /[A-Z]/.test(pass),
        nonWords: /\W/.test(pass),
      }

      let variationCount = 0
      for (let check in variations) {
        variationCount += (variations[check] === true) ? 1 : 0
      }
      score += (variationCount - 1) * 10

      return parseInt(score)
    },

    checkPasswordStrength (pass) {
      const score = this.scorePassword(pass)
      if (score > 80) {
        this.passwordStrength = { score: 'STRONG', color: 'green' }
      } else if (score > 70) {
        this.passwordStrength = { score: 'GOOD', color: 'yellow' }
      } else if (score >= 40) {
        this.passwordStrength = { score: 'WEAK', color: 'orange' }
      } else {
        this.passwordStrength = { score: 'BAD', color: 'red' }
      }
    },

    completeWelcome (valid) {
      if (this.loading || !valid || this.model.password !== this.model.password2) return
      this.loading = true

      const data = {
        _id: this.model._id,
        firstname: this.model.firstname,
        lastname: this.model.lastname,
        login_name: this.model.login_name,
        password: this.model.password,
        email: this.model.email
      }

      this.$http.post('/completeWelcome', data)
        .then(() => {
          this.loading = false
          router.push({ path: `/auth/login` })
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.loading = false
        })
    },

    clearForm (reset) {
      reset()
      this.model = {}
    }
  }
})
</script>
